module.exports = __webpack_public_path__ + "static/sui-checkbox-disabled-1bc48962011a39dfa489d493d7ab1f2a.png";